import { SlotType } from "@/api/slots";
import { create } from "zustand";
interface SuspensionType {
    able: boolean;
}
export interface ActivityState {
    slotsData: SlotType | null;
    redPacketsData: any | null;
}

interface Actions {
    setSlotsData: (values: ActivityState["slotsData"]) => void;
    setRedPacketsData: (values: ActivityState["redPacketsData"]) => void;
    // reset: () => void;
}

const initialState: ActivityState = {
    slotsData: null,
    redPacketsData: null,
};

export const useActivityStore = create<ActivityState & Actions>((set, getState) => {
    return {
        ...initialState,
        setSlotsData: (values: ActivityState["slotsData"]) =>
            set((state) => ({ ...state, slotsData: values })),
        setRedPacketsData: (values: ActivityState["redPacketsData"]) => {
            set((state) => ({ ...state, redPacketsData: values }));
        },
    };
});
